// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-component[data-v-56f9ea56]{background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}@media screen and (min-width:560px){.error-component>.error-content[data-v-56f9ea56]{width:70%;margin:0 auto;padding:0}}@media screen and (min-width:960px){.error-component>.error-content[data-v-56f9ea56]{width:50%;margin:0 auto;padding:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
